import { useCallback } from "react";
import { useSWRConfig } from "swr";
import { inboxService } from "../../api_client";

/**
 * Imperative mutators for the inbox. Both helpers refresh every cached SWR
 * key in the inbox/unread-count namespace so the bell badge and the dropdown
 * stay in sync after a read.
 */
export function useInboxMutations() {
  const { mutate } = useSWRConfig();

  const revalidate = useCallback(() => {
    return mutate(
      (key) =>
        typeof key === "string" &&
        (key.startsWith("my-inbox") || key === "my-inbox-unread-count"),
      undefined,
      { revalidate: true },
    );
  }, [mutate]);

  const markRead = useCallback(
    async (id: string) => {
      await inboxService.markInboxItemRead(id);
      await revalidate();
    },
    [revalidate],
  );

  const markAllRead = useCallback(async () => {
    await inboxService.markAllInboxRead();
    await revalidate();
  }, [revalidate]);

  return { markRead, markAllRead };
}
